document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.querySelector('.product-form'); // カートに追加ボタンを含むフォームのセレクタ
  if (productForm) {
    productForm.addEventListener('submit', function(event) {
      const agreePrivacyCheckbox = document.getElementById('agree_privacy');
      if (!agreePrivacyCheckbox.checked) {
        event.preventDefault(); // フォームの送信を停止
        alert('プライバシーポリシーに同意してください。'); // アラート表示（よりユーザーフレンドリーな表示にすることも可能です）
        return false;
      }
    });
  }
});